module.exports = __webpack_public_path__ + "static/media/main.feb8a7c4.png";